import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type ILayoutMAtSlice from './interfaces/ILayoutMAtSlice';
import type ISectionItem from './interfaces/ISectionItem';

export const initialState: ILayoutMAtSlice = {
  loading: false,
  sections: [],
};

export const layoutsMASlice = createSlice({
  name: 'layoutsMA',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setSections: (state, { payload }: PayloadAction<ISectionItem[]>) => {
      state.sections = payload;
    },
    resetState: () => initialState,
  },
});

export const { setLoading, setSections, resetState } = layoutsMASlice.actions;

export default layoutsMASlice.reducer;
